module.exports = __webpack_public_path__ + "static/logo-pcawg-5e5a1274dbc67200ba05de8b0108cc63.png";